import React from 'react';
import './howitwork.css';
import createIcon from '../assets/admin/icon1.png'; // Replace with your actual icon path
import inviteIcon from '../assets/images/icon6.png';
import receiveIcon from '../assets/images/icon7.png';
import awardIcon from '../assets/admin/icon4.png';

const Howitwork = () => {
  return (
    <>
        <h2 className="textwhite text-center mb-5">How It work</h2>

    <div className="howitworkscreen py-5">
      <div className="container text-center">
        <div className="row">
          <div className="col-md-3 mb-4">
            <div className="card shadow-lg p-3 howitcard active">
              <img src={createIcon} className="mx-auto mb-3" height="40" alt="Create RFQ" />
              <h5 className="font-weight-bold">CREATE RFQ</h5>
              <p className="text-muted small">
                Submit a clear request detailing what you need—products, services, quantities, and delivery requirements.
              </p>
            </div>
          </div>
          <div className="col-md-3 mb-4">
            <div className="card shadow-sm p-3 howitcard">
              <img src={inviteIcon} className="mx-auto mb-3" height="40" alt="Invite Vendors" />
              <h5 className="font-weight-bold">INVITE VENDORS</h5>
              <p className="text-muted small">
                Share your RFQ with trusted vendors or let new suppliers discover and respond to it on the platform.
              </p>
            </div>
          </div>
          <div className="col-md-3 mb-4">
            <div className="card shadow-sm p-3 howitcard">
              <img src={receiveIcon} className="mx-auto mb-3" height="40" alt="Receive Quotes" />
              <h5 className="font-weight-bold">RECEIVE & COMPARE QUOTES</h5>
              <p className="text-muted small">
                Vendors submit competitive offers. Compare prices, timelines, and terms side-by-side.
              </p>
            </div>
          </div>
          <div className="col-md-3 mb-4">
            <div className="card shadow-sm p-3 howitcard">
              <img src={awardIcon} className="mx-auto mb-3" height="40" alt="Award Bid" />
              <h5 className="font-weight-bold">AWARD THE BID</h5>
              <p className="text-muted small">
                Choose the best fit for your project and notify the winning vendor—all in one place.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>

  );
};

export default Howitwork;
